import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

import {getEsigText} from './CreateUpdateReviewModal';
import {ReviewAction} from './ReviewConstants';

interface EsignatureStatementProps {
  action: ReviewAction | null;
  buttonText: string;
}

export function EsignatureStatement({action, buttonText}: EsignatureStatementProps): JSX.Element {
  const text = getEsigText(action, buttonText);
  return (
    (BenchlingConfig.ENABLE_ELN_ESIGNATURE && text != null && (
      <div className={css(styles.bottomMargin)}>
        <InlineBanner bannerType={InlineBannerType.INFO} text={text} />
      </div>
    )) || <></>
  );
}

const styles = StyleSheet.create({
  bottomMargin: {
    marginBottom: '16px',
  },
});
